import "../styles/fortune-tell.css";
import GoogleAD from "../ads/google-ad";
import { useState, useEffect } from "react";
import AnalysisService from "../service/analysis-service";
import DataCenterService from "../service/data-center-service";

const FortuneTellingComponent = () => {
  const [calendarType, setCalendarType] = useState("solar");
  const [gender, setGender] = useState("1");
  const [year, setYear] = useState(2025);
  const [month, setMonth] = useState(1);
  const [day, setDay] = useState(1);
  const [hour, setHour] = useState("12");
  const [minute, setMinute] = useState("00");
  const [baZiProfile, setBaZiProfile] = useState(null);
  const [baziDataArray, setBaziDataArray] = useState([]);
  //０:起始輸入畫面 1:結果畫面
  const [state, setState] = useState("0");

  const elementClassMap = {
    木: "text-wood",
    火: "text-fire",
    土: "text-earth",
    金: "text-gold",
    水: "text-water",
  };

  const yearOptions = [];

  const currentYear = new Date().getFullYear(); // 取得今年西元年

  for (let y = 1912; y <= currentYear; y++) {
    const roc = y - 1911;
    yearOptions.push(
      <option key={y} value={y}>
        民國 {roc}（西元 {y}）
      </option>
    );
  }
  const monthOptions = [];

  for (let m = 1; m <= 12; m++) {
    monthOptions.push(
      <option key={m} value={m}>
        {m}
      </option>
    );
  }

  const dayOptions = [];

  for (let m = 1; m <= 31; m++) {
    dayOptions.push(
      <option key={m} value={m}>
        {m}
      </option>
    );
  }

  const hourOptions = [];

  for (let m = 0; m <= 23; m++) {
    hourOptions.push(
      <option key={m} value={m}>
        {m.toString().padStart(2, "0")}
      </option>
    );
  }

  const minuteptions = [];

  for (let m = 0; m <= 59; m++) {
    minuteptions.push(
      <option key={m} value={m}>
        {m.toString().padStart(2, "0")}
      </option>
    );
  }

  //開始計算八字
  const handleFortuneCalu = async (e) => {
    const realHour = parseInt(hour, 10);
    const realMinute = parseInt(minute, 10);

    const response = await AnalysisService.analyticsUserEightChar(
      year,
      month,
      day,
      realHour,
      realMinute,
      gender,
      calendarType
    );

    setBaZiProfile(response.data.data);
    console.log(anaBaziDataArray(response.data.data.eightChar));
    setBaziDataArray(anaBaziDataArray(response.data.data.eightChar));
    setState("1");

    //紀錄流量到資料庫
    DataCenterService.trackSimpleBaiFlow();
  };

  const handleReset = async (e) => {
    setBaZiProfile(null);
    setState("0");
  };

  //分析輸出八字資料陣列
  function anaBaziDataArray(eightChar) {
    return [
      // 前6列，每2列一組、每3欄合併成1格，共5格 (因為 13欄 ≈ 4組3欄 + 1欄沒合併，為簡化這裡先做5組)
      // 總共8列，最後2列不合併
      [
        [
          eightChar.timeColumn.shiShen,
          null,
          null,
          "日主",
          null,
          null,
          eightChar.monthColumn.shiShen,
          null,
          null,
          eightChar.yearColumn.shiShen,
          null,
          null,
          "十神",
        ],
        [
          null,
          null,
          null,
          null,
          null,
          null,
          null,
          null,
          null,
          null,
          null,
          null,
          null,
        ],
      ],
      [
        [
          eightChar.timeColumn.sky,
          null,
          null,
          eightChar.dayColumn.sky,
          null,
          null,
          eightChar.monthColumn.sky,
          null,
          null,
          eightChar.yearColumn.sky,
          null,
          null,
          "天干",
        ],
        [
          null,
          null,
          null,
          null,
          null,
          null,
          null,
          null,
          null,
          null,
          null,
          null,
          null,
        ],
      ],
      [
        [
          eightChar.timeColumn.land,
          null,
          null,
          eightChar.dayColumn.land,
          null,
          null,
          eightChar.monthColumn.land,
          null,
          null,
          eightChar.yearColumn.land,
          null,
          null,
          "地支",
        ],
        [
          null,
          null,
          null,
          null,
          null,
          null,
          null,
          null,
          null,
          null,
          null,
          null,
          null,
        ],
      ],
      // 最後兩列正常13欄不合併
      [
        eightChar.timeColumn.innerShiShen[2].sky,
        eightChar.timeColumn.innerShiShen[1].sky,
        eightChar.timeColumn.innerShiShen[0].sky,
        eightChar.dayColumn.innerShiShen[2].sky,
        eightChar.dayColumn.innerShiShen[1].sky,
        eightChar.dayColumn.innerShiShen[0].sky,
        eightChar.monthColumn.innerShiShen[2].sky,
        eightChar.monthColumn.innerShiShen[1].sky,
        eightChar.monthColumn.innerShiShen[0].sky,
        eightChar.yearColumn.innerShiShen[2].sky,
        eightChar.yearColumn.innerShiShen[1].sky,
        eightChar.yearColumn.innerShiShen[0].sky,
        "藏干",
      ],
      [
        eightChar.timeColumn.innerShiShen[2].shiShen,
        eightChar.timeColumn.innerShiShen[1].shiShen,
        eightChar.timeColumn.innerShiShen[0].shiShen,
        eightChar.dayColumn.innerShiShen[2].shiShen,
        eightChar.dayColumn.innerShiShen[1].shiShen,
        eightChar.dayColumn.innerShiShen[0].shiShen,
        eightChar.monthColumn.innerShiShen[2].shiShen,
        eightChar.monthColumn.innerShiShen[1].shiShen,
        eightChar.monthColumn.innerShiShen[0].shiShen,
        eightChar.yearColumn.innerShiShen[2].shiShen,
        eightChar.yearColumn.innerShiShen[1].shiShen,
        eightChar.yearColumn.innerShiShen[0].shiShen,
        "藏干",
      ],
    ];
  }

  const [isMobile, setIsMobile] = useState(window.innerWidth <= 1024);

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 1024);
    };

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  // 監聽 popstate，控制返回從結果頁 → 輸入頁
  useEffect(() => {
    // 當 state === "1"，加入一筆 history
    if (state === "1") {
      window.history.pushState({ page: "1" }, "", window.location.href);
    }
  }, [state]);

  useEffect(() => {
    const handlePopState = () => {
      setState((prev) => {
        if (prev === "1") {
          // 回到初始畫面
          return "0";
        }
        return prev; // 如果是 "0" 就保持不變（真正返回瀏覽器上一頁）
      });
    };

    window.addEventListener("popstate", handlePopState);
    return () => {
      window.removeEventListener("popstate", handlePopState);
    };
  }, []);

  return (
    <div className="fortune-tell">
      <div className="title">
        <div className="logo">
          <img src={`/images/ic-web-logo.png`} alt="web logo" />
        </div>
      </div>

      <main>
        {!isMobile && (
          <div className="ad">
            <p>廣告贊助</p>

            {/* 自己的廣告 */}
            <div className="ad-self">
              <a
                href="https://lottoto.onelink.me/nCmE/n5zrgmek"
                target="_blank"
                rel="noopener noreferrer"
              >
                <img src={`/images/lotto-1.png`} alt="贊助圖片" />
              </a>

              <a
                href="https://lottoto.onelink.me/nCmE/n5zrgmek"
                target="_blank"
                rel="noopener noreferrer"
              >
                <img src={`/images/lotto-2.png`} alt="贊助圖片" />
              </a>
            </div>

            <div className="google-ad">
              <GoogleAD />
            </div>
          </div>
        )}

        <div className="display">
          {state === "0" && (
            <div className="input">
              <div className="title-hint">
                <div className="tag"></div>
                <p>免費八字算命</p>
              </div>

              <p className="select-hint">你的出生日期</p>

              <div className="select-radio">
                <div className="option">
                  <input
                    type="radio"
                    name="calendar"
                    id="solar"
                    value="solar"
                    checked={calendarType === "solar"}
                    onChange={() => setCalendarType("solar")}
                  />
                  <label htmlFor="solar">國曆</label>
                </div>

                <div className="option">
                  <input
                    type="radio"
                    name="calendar"
                    id="lunar"
                    value="lunar"
                    checked={calendarType === "lunar"}
                    onChange={() => setCalendarType("lunar")}
                  />
                  <label htmlFor="lunar">農曆</label>
                </div>
              </div>

              <div className="select-birth">
                <div className="select-opt  select-opt-year">
                  <div className="select-tag">
                    <p className="tag">年份</p>
                    <i class="bi bi-caret-down-fill"></i>
                  </div>

                  <select
                    id="year-select"
                    className="form-select"
                    style={{
                      appearance: "none",
                      WebkitAppearance: "none",
                      MozAppearance: "none",
                      backgroundImage: "none",
                      boxShadow: "none", // 移除陰影效果
                    }}
                    value={year}
                    onChange={(e) => setYear(parseInt(e.target.value))}
                  >
                    {yearOptions}
                  </select>
                </div>

                <div className="space"></div>

                <div className="select-opt">
                  <div className="select-tag">
                    <p className="tag">月份</p>
                    <i class="bi bi-caret-down-fill"></i>
                  </div>

                  <select
                    id="month-select"
                    className="form-select"
                    style={{
                      appearance: "none",
                      WebkitAppearance: "none",
                      MozAppearance: "none",
                      backgroundImage: "none",
                      boxShadow: "none", // 移除陰影效果
                    }}
                    value={month}
                    onChange={(e) => setMonth(parseInt(e.target.value))}
                  >
                    {monthOptions}
                  </select>
                </div>

                <div className="space"></div>

                <div className="select-opt">
                  <div className="select-tag">
                    <p className="tag">日期</p>
                    <i class="bi bi-caret-down-fill"></i>
                  </div>
                  <select
                    id="day-select"
                    className="form-select"
                    style={{
                      appearance: "none",
                      WebkitAppearance: "none",
                      MozAppearance: "none",
                      backgroundImage: "none",
                      boxShadow: "none", // 移除陰影效果
                    }}
                    value={day}
                    onChange={(e) => setDay(parseInt(e.target.value))}
                  >
                    {dayOptions}
                  </select>
                </div>
              </div>

              <div className="select-birth">
                <div className="select-opt">
                  <div className="select-tag">
                    <p className="tag">出生-時</p>
                    <i class="bi bi-caret-down-fill"></i>
                  </div>

                  <select
                    id="hour-select"
                    className="form-select"
                    style={{
                      appearance: "none",
                      WebkitAppearance: "none",
                      MozAppearance: "none",
                      backgroundImage: "none",
                      boxShadow: "none", // 移除陰影效果
                    }}
                    value={hour}
                    onChange={(e) => setHour(parseInt(e.target.value))}
                  >
                    {hourOptions}
                  </select>
                </div>

                <div className="space time-space"></div>

                <div className="select-opt">
                  <div className="select-tag">
                    <p className="tag">出生-分</p>
                    <i class="bi bi-caret-down-fill"></i>
                  </div>

                  <select
                    id="minute-select"
                    className="form-select"
                    style={{
                      appearance: "none",
                      WebkitAppearance: "none",
                      MozAppearance: "none",
                      backgroundImage: "none",
                      boxShadow: "none", // 移除陰影效果
                    }}
                    value={minute}
                    onChange={(e) => setMinute(parseInt(e.target.value))}
                  >
                    {minuteptions}
                  </select>
                </div>
              </div>

              <p className="select-hint">性別</p>

              <div className="select-radio">
                <div className="option">
                  <input
                    type="radio"
                    name="gender"
                    id="male"
                    value="1"
                    checked={gender === "1"}
                    onChange={() => setGender("1")}
                  />
                  <label htmlFor="male">男性</label>
                </div>

                <div className="option">
                  <input
                    type="radio"
                    name="gender"
                    id="female"
                    value="0"
                    checked={gender === "0"}
                    onChange={() => setGender("0")}
                  />
                  <label htmlFor="female">女性</label>
                </div>
              </div>

              <div className="start-analytics">
                <button onClick={handleFortuneCalu}>命盤分析</button>
              </div>
            </div>
          )}

          {state === "1" && (
            <div className="result">
              <div className="user-info">
                <div className="title-hint">
                  <div className="tag"></div>
                  <p>你的資料</p>
                </div>

                <div className="info-table">
                  <table
                    style={{
                      width: "100%",
                    }}
                  >
                    <tr className="general">
                      <td className="general">
                        西元：{baZiProfile.solarBirth}
                      </td>
                      <td className="general self-tag">你是...</td>
                    </tr>
                    <tr className="general">
                      <td className="general">
                        農曆：{baZiProfile.lunarBirth}
                      </td>
                      <td
                        className={`merge ${
                          elementClassMap[baZiProfile.outerType]
                        }`}
                        rowspan="2"
                      >
                        【{baZiProfile.eightChar.dayColumn.sky}
                        {baZiProfile.outerType}】人
                      </td>
                    </tr>
                    <tr className="general">
                      <td className="general">
                        時間：{baZiProfile.birthTime} (
                        {baZiProfile.eightChar.timeColumn.land}時)
                      </td>
                    </tr>
                  </table>
                </div>

                <div className="reset-analytics">
                  <button onClick={handleReset}>分析新命盤</button>
                </div>
              </div>

              <div className="peronsal-type">
                <div className="title-hint">
                  <div className="tag"></div>
                  <p>命盤重點</p>
                </div>

                <div className="personal">
                  <p className="personal-title">
                    【{baZiProfile.eightChar.dayColumn.sky}
                    {baZiProfile.outerType}】人 &nbsp;&nbsp;外在解析
                  </p>

                  <p className="personal-intro">
                    {baZiProfile.personalDes.description_ZH}
                  </p>
                </div>
              </div>

              <div className="bazi-result">
                <div className="title-hint">
                  <div className="tag"></div>
                  <p>八字命盤</p>
                </div>

                <div className="bazi-table">
                  <table style={{ borderCollapse: "collapse", width: "100%" }}>
                    <tbody>
                      {baziDataArray.map((row, rowIndex) => {
                        if (Array.isArray(row[0])) {
                          return row.map((subRow, subIndex) => {
                            return (
                              <tr
                                key={`row-${rowIndex}-${subIndex}`}
                                className="general"
                              >
                                {subRow.map((cell, colIndex) => {
                                  if (cell === null) return null;

                                  const isLastColumn =
                                    colIndex === subRow.length - 1;

                                  // 加上額外樣式
                                  let extraClass = "";

                                  if (isLastColumn) {
                                    extraClass = "special-last-column";
                                  } else if (rowIndex === 1 || rowIndex === 2) {
                                    extraClass = "highlight";
                                  }

                                  return (
                                    <td
                                      key={`cell-${rowIndex}-${subIndex}-${colIndex}`}
                                      rowSpan={subIndex === 0 ? 2 : undefined}
                                      colSpan={3}
                                      className={`vertical-text ${extraClass}`}
                                    >
                                      <span
                                        className={`merged-cell ${extraClass}`}
                                      >
                                        {cell}
                                      </span>
                                    </td>
                                  );
                                })}
                              </tr>
                            );
                          });
                        }

                        // 後兩列（非合併）
                        return (
                          <tr key={`row-${rowIndex}`} className="general">
                            {row.map((cell, colIndex) => {
                              const isLastColumn = colIndex === row.length - 1;
                              return (
                                <td
                                  key={`cell-${rowIndex}-${colIndex}`}
                                  className={`vertical-text ${
                                    isLastColumn ? "special-last-column" : " "
                                  }`}
                                >
                                  <span
                                    className={` ${
                                      isLastColumn ? "special-last-column" : " "
                                    }`}
                                  >
                                    {cell === "" ? "\u00A0" : cell}
                                  </span>
                                </td>
                              );
                            })}
                          </tr>
                        );
                      })}
                    </tbody>
                  </table>

                  <div className="table-wrapper" style={{ width: "100%" }}>
                    {/* 第一、二列 */}
                    <table className="three-cols">
                      <tbody>
                        <tr>
                          <td colSpan={2}>
                            命卦：{baZiProfile.hexagram.hexagramName}
                            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                            {baZiProfile.hexagram.direction}
                          </td>
                          <td>{baZiProfile.physique}</td>
                        </tr>
                        <tr>
                          <td>馬：{baZiProfile.kuMaHua.ma}</td>
                          <td>花：{baZiProfile.kuMaHua.fl}</td>
                          <td>庫：{baZiProfile.kuMaHua.ku}</td>
                        </tr>
                      </tbody>
                    </table>

                    {/* 第三列 */}
                    <table className="five-cols">
                      <tbody>
                        <tr>
                          <td>木：{baZiProfile.elements.wood}</td>
                          <td>火：{baZiProfile.elements.fire}</td>
                          <td>土：{baZiProfile.elements.earth}</td>
                          <td>金：{baZiProfile.elements.metal}</td>
                          <td>水：{baZiProfile.elements.water}</td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>
          )}

          <div className="teacher">
            <div className="info">
              <a
                href="https://line.me/ti/p/yeb8taPMKG#~"
                target="_blank"
                rel="noopener noreferrer"
              >
                <img src={`/images/jerry-info.png`} alt="老師資訊" />
              </a>
            </div>

            <div className="info">
              <a
                href="https://five-element.onelink.me/6d3j/7o0z9imf"
                target="_blank"
                rel="noopener noreferrer"
              >
                <img src={`/images/jerry-app.png`} alt="老師資訊" />
              </a>
            </div>
          </div>

          {isMobile && (
            <div className="mobile-sponsor">
              <p>廣告贊助</p>
              <div className="ad-self">
                <a
                  href="https://lottoto.onelink.me/nCmE/n5zrgmek"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <img src={`/images/lotto-1.png`} alt="贊助圖片" />
                </a>
                <a
                  href="https://love-push.onelink.me/RSmv/meitkglh"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <img src={`/images/love-1.png`} alt="贊助圖片" />
                </a>
              </div>
            </div>
          )}
        </div>

        {!isMobile && (
          <div className="ad">
            <p>廣告贊助</p>

            {/* 自己的廣告 */}
            <div className="ad-self">
              <a
                href="https://love-push.onelink.me/RSmv/meitkglh"
                target="_blank"
                rel="noopener noreferrer"
              >
                <img src={`/images/love-1.png`} alt="贊助圖片" />
              </a>

              <a
                href="https://love-push.onelink.me/RSmv/meitkglh"
                target="_blank"
                rel="noopener noreferrer"
              >
                <img src={`/images/love-2.png`} alt="贊助圖片" />
              </a>
            </div>

            <div className="google-ad">
              <GoogleAD />
            </div>
          </div>
        )}
      </main>
    </div>
  );
};

export default FortuneTellingComponent;
